import { render, staticRenderFns } from "./billingSingle.vue?vue&type=template&id=bdfa7d64"
import script from "./billingSingle.vue?vue&type=script&lang=js"
export * from "./billingSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports